/**
 * this script offers a lazy load approach to the Searchanise widget and fixes some issues
 * it has no use without the Searchanise app
 */
(function () {
  document.addEventListener("Searchanise.Loaded", function () {
    // fix search results
    // Searchanise can't handle localized URLs and their API is sending out corrupted URLs that need manual fixing
    const origjQueryFunc = window.Searchanise.$.getJSON;
    window.Searchanise.$.getJSON = function () {
      const args = Array.prototype.slice.call(arguments);
      const url = args[0];
      const success = args[1];
      if (url.includes("https://searchserverapi.com/getwidgets")) {
        window.Searchanise.$.ajax({
          dataType: "json",
          url: args[0],
          success: (data) => {
            // transform data
            const regexp = /(\/[a-z]{2})?\/(collections|products|pages)\/.*$/
            // replace links in categories, items, pages
            const properties = ["categories", "items", "pages"];
            properties.forEach((property) => {
              if (!data[property]) return true;
              data[property].forEach((item) => {
                item.link = item.link.match(regexp) ? item.link.match(regexp)[0] : item.link;
              });
            });
            // call the original success function from searchanise
            success(data);
          }
        });
      } else {
        return origjQueryFunc.apply(this, args);
      }
    }
  }, { once: true });
})();

(function () {
  // we don't want to delay loading on the searchanise search page
  var loadanise = document.location.pathname.includes('/pages/search-results-page');
  if (loadanise) return;

  // snippets/header-essentials.liquid must be loaded first
  // intercept searchanise assets
  window.TitusObserver.subscribeAppend({
    test: (aChild) => {
      return !loadanise 
        && (
          (
            aChild.tagName === "SCRIPT" &&
            aChild.src.includes("searchanise")
          ) || (
            aChild.tagName === "LINK" &&
            aChild.rel === "stylesheet" &&
            aChild.href.includes("searchanise")
          )
        )
    },
    transform: (aChild, origAppend) => {},
  });

  // set up listeners on all search inputs to load searchanise on interaction
  var searchLinks = document.querySelectorAll('a[href="/search"]');
  var searchInputs = document.querySelectorAll('input[type="search"]');
  // merge searchLinks and searchInputs node lists
  var elements = Array.prototype.slice.call(searchInputs).concat(Array.prototype.slice.call(searchLinks));
  setEventListeners = function (type, listener) {
    elements.forEach(function (element) {
      element.addEventListener(type, listener);
    });
  }
  removeEventListeners = function (type, listener) {
    elements.forEach(function (element) {
      element.removeEventListener(type, listener);
    });
  };

  if (elements.length > 0) {
    var listener = async function (e) {
      // prevent the logic to run multiple times if you click on multiple search inputs
      if (loadanise) return;
      // set loadise to true so scripts can load
      loadanise = true;

      // we need to wait for window.Searchanise (https://searchserverapi.com/widgets/shopify/init.js)
      await window.TitusObjectObserver.observe('Searchanise', window, 50).catch((e) => { throw new Error('Searchanise could not load', e); });

      if (window.Searchanise) {
        // set search path to native search
        if (theme.settings.useNativeSearchInWidget) window.Searchanise.options.ResultsFormPath = '/search';

        document.addEventListener("Searchanise.Loaded", function (event) {
          // add promise that resolves when Searchanise.$(Searchanise.SearchInput).attr('autocomplete') is set
          // this is required because the search input events are not properly set up when Searchanise.Loaded fires
          // the searchanise function that sets the events also sets the autocomplete attribute
          // so we can use it as workaround
          window.TitusObjectObserver.observeCustom(
            () => Searchanise.$(Searchanise.SearchInput).attr("autocomplete") !== undefined, 
            50
          ).then(function () {
            $searchInput = Searchanise.$(Searchanise.SearchInput).filter(Searchanise.$(document.activeElement));
            if ($searchInput.length > 0) {
              $searchInput.trigger("touchstart");
              $searchInput.trigger("keydown");
              $searchInput.trigger("click");
            }

            // on mobile devices bring up search on keydown
            // this fixes an issue that you sometimes have to click twice to bring up the Searchanise widget
            const autocomplete = Searchanise.$(Searchanise.SearchInput).data('autocompleter').select;
            if (autocomplete.isMobileMode()) {
              Searchanise.$(Searchanise.SearchInput).on("keydown", function (e) {
                if (!autocomplete.visible()) {
                  autocomplete.init();
                  autocomplete.show();
                }
              });
            }
          }).catch(() => {});
        }, { once: true });

        /**
         * init searchanise
         * this is a copy pasta from https://searchserverapi.com/widgets/shopify/init.js
         *  o.loader.init((function() {
                o.Init(),
                o.SetPaths(o.paths),
                o.SetOptions(e.Searchanise.templates),
                o.SetOptions(o.userOptions),
                o.SetParams(o.AutoCmpParams),
                o.SetResultsParams(o.ResultsParams),
                o.Loaded = !0,
                o.triggerDocumentEvent("Searchanise.Loaded"),
                o.HandleStart()
            }
         */
        // load jquery before everything else because it's required by searchanise
        await window.loadJQuery().catch((e) => { throw new Error('Searchanise could not load', e); });
        window.Searchanise.$ = window.jQuery.noConflict(true);
        window.Searchanise.loader.jqLoaded();
        window.Searchanise.loader.init(async function () {
          // not sure why, but we need to wait for this to be set
          // the native function handles this just fine and only fires the callback once widgets.js is loaded
          // but our lazy approach fires too early and Init isn't set yet
          await window.TitusObjectObserver.observe('Searchanise.Init', window, 50).catch((e) => { throw new Error('Searchanise could not load', e); });
          window.Searchanise.Init();
          window.Searchanise.SetPaths(window.Searchanise.paths);
          window.Searchanise.SetOptions(window.Searchanise.templates);
          window.Searchanise.SetOptions(window.Searchanise.userOptions);
          window.Searchanise.SetParams(window.Searchanise.AutoCmpParams);
          window.Searchanise.SetResultsParams(
            window.Searchanise.ResultsParams
          );
          (window.Searchanise.Loaded = !0);
          window.Searchanise.triggerDocumentEvent("Searchanise.Loaded");
          window.Searchanise.HandleStart();
        });
      }

      // listeners trigger once, but per element. So we need to remove them anyway.
      removeEventListeners("focus", listener);
      removeEventListeners("keydown", listener);
      removeEventListeners("click", listener);
    };

    // add listeners
    setEventListeners("focus", listener);
    setEventListeners("keydown", listener);
    setEventListeners("click", listener);
  }
})();
